<!--
 * @Description: 取货人
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-17 13:40:37
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-01-17 17:57:15
-->
<template>
  <div class="pick-up-add-row">
    <van-form @submit="submit">
      <div class="pick-up-add-card">
        <van-field
          v-model="form.name"
          label-class="form-label"
          label="收货人"
          input-align="right"
          placeholder="请填写收货人姓名"
          maxlength="30"
          :rules="[{ required: true }]"
        />
        <van-field
          v-model="form.phone"
          label-class="form-label"
          label="手机号码"
          input-align="right"
          error-message-align="right"
          placeholder="请填写收货人手机号"
          type="number"
          :maxlength="11"
          :rules="[{required: true, pattern:$pattern.phone, message: `${form.phone?'请输入正确的手机号':''}`, trigger: 'blur'},]"
        />
        <van-field
          :value="city"
          label-class="form-label"
          label="所在地区"
          input-align="right"
          placeholder="省市区县、乡镇等"
          readonly
          :rules="[{ required: true }]"
          @click="showCity"
        />
        <van-field
          v-model="form.address"
          label-class="form-label"
          label="详细地址"
          input-align="right"
          placeholder="街道、楼牌号等"
          :rules="[{ required: true }]"
          maxlength="50"
        />
      </div>
      <div class="pick-up-add-card address-default">
        <div class="form-label" style="flex:1">设为默认地址</div>
        <div>
          <van-switch 
            :active-value="1" 
            :inactive-value="0"
            v-model="form.defaultAddress" 
            active-color="#00BCD1" 
            inactive-color="#EAEAEA" 
           />
        </div>
      </div>
      <div class="yplus-button-row">
        <div class="yplus-button-row button-fixed">
          <div style="width:28vw;margin-right:4.2vw" v-if="addressId">
            <van-button native-type="button" color="#00BCD1" block plain @click="deleteAddress">删除</van-button>
          </div>
          <div style="flex:1">
            <van-button native-type="submit" color="#00BCD1" block>{{submitText||'保存并使用'}}</van-button>
          </div>
        </div>
      </div>
    </van-form>
    <van-popup v-model="show" round position="bottom">
      <van-cascader
        v-model="cascaderValue"
        title="请选择所在地区"
        :options="options"
        @close="show = false"
        @finish="onFinish"
        active-color="#00BCD1"
        :field-names="fieldNames"
        @change="onChange"
      />
    </van-popup>
  </div>
</template>

<script>
import { Toast,Dialog } from 'vant';
export default {
  // metaInfo() {
  //   return {
  //     title: this.addressId ? "编辑收货地址" : "新增收货地址"
  //   };
  // },
  props:{
    value:{
      type:[Number,String],
      default:''
    },
    submitText:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      form: {
        name: "",
        phone: "",
        provinceId:'',
        provinceName:'',
        cityId:'',
        cityName:'',
        districtName:'',
        districtId:'',
        streetName:'',
        streetId:'',
        address:'',
        defaultAddress:0,
        typeCode:'JD'
      },
      fieldNames: {
        text: 'text',
        value: 'districtCode'
      },
      options:[],
      nowchildren:[],
      show: false,
      addressId:'',
      cascaderValue:'',
      cascaderValueArr:[]
    };
  },
  computed: {
    disabled() {
      return true;
    },
    city(){
      console.log(this.form.streetName)
        return this.form.provinceName?`${this.form.provinceName} ${this.form.cityName} ${this.form.districtName} ${this.form.streetName||''}` :''
    },
    // cascaderValue(){
    //     return this.form.districtId
    // }
  },
  watch:{
    cascaderValue(val){
      console.log(val)
    } 
  },
  created(){
  },
  methods: {
    init(id){
      this.getCityList()
      this.addressId = id||''
      if(id){
        this.getDetail()
      }else{
        this.form = Object.assign(this.$data.form,this.$options.data().form)
      }
    },
    submit() {
        let params = this.form
        params['patientId'] = this.$store.getters.userInfo.id
        this.$store.dispatch('address/addOrUpdate',params).then((data)=>{
            Toast({
                message:'保存成功',
                forbidClick:true,
                onClose: () => {
                  if(this.$listeners['submit']){
                    this.$emit('submit',data)
                  }
                  this.$emit('back')
                },
            })
            
        })
    },
    //删除
    deleteAddress(){
        Dialog.confirm({
            showCancelButton:true,
            confirmButtonColor:'#00BCD1',
            message: '是否删除该地址',
        })
        .then(() => {
            // on confirm
            this.$store.dispatch('address/deleteAddress',{id:this.addressId}).then((data)=>{
              Toast({
                message:'删除成功',
                forbidClick:true,
                onClose: () => {
                  if(this.value === this.addressId){
                    this.$emit('input','')
                  }
                  this.$emit('back')
                },
              })
            })
        })
    },
    getCityList(){
          if(this.options.length>0){
            return
          }
         this.api.sys.getSysRegionTreeByJd({}).then(({ data }) => {
            let arr = data.map((v,i)=>({...v,children:[],index:i}))
            this.nowchildren = arr
            this.options = arr
         })
    },
    getDetail(){
        this.api.address.getDetail({id:this.addressId}).then(({data})=>{
            this.form = data
            this.getCityList()
        })
        
    },
    showCity(){
      this.show = true
      this.cascaderValue = this.form.streetId || this.form.districtId
    },
    onFinish( { selectedOptions} ){
        this.show = false
        this.form['provinceId'] = selectedOptions[0].districtCode
        this.form['provinceName'] = selectedOptions[0].text
        this.form['cityId'] = selectedOptions[1].districtCode
        this.form['cityName'] = selectedOptions[1].text
        this.form['districtId'] = selectedOptions[2].districtCode
        this.form['districtName'] = selectedOptions[2].text
        this.form['jdProvinceCode'] = selectedOptions[0].districtCode
        this.form['jdCityCode'] = selectedOptions[1].districtCode
        this.form['jdDistrictCode'] = selectedOptions[2].districtCode
        console.log(selectedOptions[3])
        if(selectedOptions[3]){
          this.form['streetId'] = selectedOptions[3].districtCode
          this.form['streetName'] = selectedOptions[3].text
          this.form['jdStreetCode'] = selectedOptions[3].districtCode
          console.log(selectedOptions)
        }else{
          this.form['streetId'] = ''
          this.form['streetName'] = ''
          this.form['jdStreetCode'] = ''
        }
         
    },

    onChange({ selectedOptions,tabIndex, value }){
      this.cascaderValueArr = selectedOptions
      console.log(this.cascaderValueArr)
      let children = selectedOptions[tabIndex].children
      if(tabIndex < 3 && children&&children.length == 0){
        this.api.sys.getSysRegionTreeByJd({parentCode:selectedOptions[tabIndex].districtCode}).then(({ data }) => {
          let arr = null
          if(data.length){
              arr = data.map((v,i)=>({...v,children:[],index:i}))
          }else{
            this.onFinish({selectedOptions})
          }
          setTimeout(() => {
            switch (tabIndex) {
              case 0:
                this.options[this.cascaderValueArr[0].index].children = arr
                break;
              case 1:
                this.options[this.cascaderValueArr[0].index].children[this.cascaderValueArr[1].index].children = arr
                break;
              case 2:
                this.options[this.cascaderValueArr[0].index].children[this.cascaderValueArr[1].index].children[this.cascaderValueArr[2].index].children = arr ? arr.map(v=>({...v,children:null})):null
                break;
              // case 3:
              //   this.options[this.cascaderValueArr[0].index].children[this.cascaderValueArr[1].index].children[this.cascaderValueArr[2].index].children[this.cascaderValueArr[3].index].children = arr
              //   break;
              default:
                break;
            }
          }, 500);
             
        })
      }
    }
  }
};
</script>

<style scoped>
.pick-up-add-row {
  min-height: 140vw;
  padding: 4.2vw;
  background-color: #f6f7f8;
}
.pick-up-add-card {
  background-color: #ffffff;
  border-radius: 2.1vw;
  overflow: hidden;
}
.yplus-button-row {
  height: 94px;
  display: flex;
}
.button-fixed {
  width: 92vw;
  left: 4vw;
  position: fixed;
  bottom: calc(16vw - 44px);
  height: 44px;
}
.delete-toast {
  color: #60646b;
  font-size: 3.7vw;
  padding: 1vw 12vw;
}
.address-default {
  padding: 10px 16px;
  display: flex;
  align-items: center;
  margin-top: 3.7vw;
}
</style>


// WEBPACK FOOTER //
// src/views/address/add.vue